<template>
  <b-modal no-close-on-backdrop ref="modal-add-questions-random" size="xl" hide-footer title="Preguntas Aleatorias"
    v-on:hide="onModalHide()">

    <div>
      <!-- Tabla -->
      <b-table :items="items" :fields="fields" class="mb-4 w-100" style="table-layout: fixed">

        <!-- Categoría -->
        <template #cell(category_id)="{ item }">
          <b-form-select v-model="item.category_id" :options="categoriesOptions" class="form-control-sm" />
        </template>

        <!-- Subcategoría -->
        <template #cell(subcategory_id)="{ item }">
          <b-form-select v-model="item.subcategory_id" :options="getSubCategoryOptions(item, item.category_id)"
            :disabled="!item.category_id" class="form-control-sm" />
        </template>

        <!-- Área de conocimiento -->
        <template #cell(knowledge_area_id)="{ item }">
          <b-form-select v-model="item.knowledge_area_id" :options="knowledgeAreaOptions" class="form-control-sm" />
        </template>

        <!-- Competencias -->
        <template #cell(competencies_id)="{ item }">
          <b-form-select v-model="item.competencies_id" :options="competencesOptions" class="form-control-sm" />
        </template>

        <!-- Dificultad -->
        <template #cell(difficulty_id)="{ item }">
          <b-form-select v-model="item.difficulty_id" :options="difficultyOptions" class="form-control-sm" />
        </template>

        <!-- Tags -->
        <template #cell(tag_id)="{ item }">
          <multiselect
            v-model="item.tag_id"
            :options="tagsOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecciona"
            label="text"
            track-by="value"
            :show-labels="false"
          >
            <template
              slot="selection"
              slot-scope="{ values, search, isOpen }"
            >
              <span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} selected</span>
            </template>
          </multiselect>
        </template>

        <!-- Cantidad -->
        <template #cell(quantity)="{ item }">
          <b-form-input v-model.number="item.quantity" type="number" min="1" class="form-control-sm" />
        </template>

        <!-- Acciones -->
        <template #cell(actions)="{ index }">
          <b-button @click="removeItem(index)" variant="danger" size="sm">
            Eliminar
          </b-button>
        </template>
      </b-table>

      <!-- Botones "Nuevo" y "Generar" -->
      <div class="d-flex justify-content-between">
        <b-button @click="addNewItem" variant="primary">
          Nuevo
        </b-button>
        <b-button @click="addQuestions" :disabled="isLoading">
          Generar
        </b-button>
      </div>
    </div>

  </b-modal>
</template>


<script>
import axios from "axios";
import Multiselect from 'vue-multiselect'

export default {
  props: {
    parentModel: String,
  },
  components: {
    Multiselect
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'category_id', label: 'Categoría' },
        { key: 'subcategory_id', label: 'Subcategoría' },
        { key: 'knowledge_area_id', label: 'Área de conocimiento' },
        { key: 'competencies_id', label: 'Competencias' },
        { key: 'difficulty_id', label: 'Dificultad' },
        { key: 'tag_id', label: 'Tags' },
        { key: 'quantity', label: 'Cantidad' },
        { key: 'actions', label: 'Acciones' }
      ],

      categoriesOptions: [],
      knowledgeAreaOptions: [],
      competencesOptions: [],
      difficultyOptions: [],
      tagsOptions: [],

      isLoading: false,     
    }
  },
  mounted() {
    this.loadDifficulty();
  },
  methods: {
    getSubCategoryOptions(item, categoryId) {
      if (categoryId) {
        const subcategories = this.categoriesResponse.find(c => c.id === categoryId).subcategoryList
        const subcategoryOptions = [{ text: 'Selecciona una subcategoría', value: null }]

        for (let subcategory of subcategories) {
          if (subcategory.deleted) {
            continue;
          }
          subcategoryOptions.push({ text: subcategory.description, value: subcategory.id })
        }

        return subcategoryOptions
      }

      return [];
    },
    async loadDifficulty() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/difficulty/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.difficultyOptions.push({
            text: "Selecciona una dificultad",
            value: null,
          });

          for (let item of arr.sort((a, b) => a.id - b.id)) {
            this.difficultyOptions.push({ text: item.description, value: item.id });
          }

          this.loadKnowledge();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async loadKnowledge() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/knowledgearea/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.knowledgeAreaOptions.push({
            text: "Selecciona un Tipo de pensamiento",
            value: null,
          });
          for (let item of arr) {
            this.knowledgeAreaOptions.push({
              text: item.description,
              value: item.id,
            });
          }
          this.loadCompetences();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async loadCompetences() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/competences/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.competencesOptions.push({
            text: "Selecciona una competencia",
            value: null,
          });
          for (let item of arr) {
            this.competencesOptions.push({ text: item.description, value: item.id });
          }
          this.loadCategories();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    loadCategories() {      
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/categories/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.categoriesResponse = arr
          this.categoriesOptions.push({
            text: "Selecciona una categoría",
            value: null,
          });
          for (let item of arr) {
            if (item.deleted) {
              continue;
            }
            this.categoriesOptions.push({ text: item.description, value: item.id });
          }

          this.loadTags();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    async loadTags() {
      let loader = this.$loading.show({});

      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/tag/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.tagsOptions.push({
            text: "Selecciona una etiqueta",
            value: null,
          });
          for (let item of arr) {
            this.tagsOptions.push({ text: item.name, value: item.id });
          }

          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    addNewItem() {
      this.items.push({
        category_id: null,
        subcategory_id: null,
        knowledge_area_id: null,
        competencies_id: null,
        difficulty_id: null,
        tag_id: null,
        quantity: 1
      });
    },
    removeItem(index) {
      this.items.splice(index, 1)
    },
    addQuestions() {
      this.isLoading = true;

      const questionsCriteria = this.items.map(item => {
        const criteria = {
          competencies_id: item.competencies_id,
          knowledge_area_id: item.knowledge_area_id,
          difficulty_id: item.difficulty_id,
          tag_ids: item.tag_id?.length ? item.tag_id.map(tag => tag.value) : null,
          quantity: item.quantity
        }

        if (item.subcategory_id) {
          criteria.subcategory_id = [item.subcategory_id]
        } else if (item.category_id) {
          criteria.subcategory_id = this.getSubCategoryOptions(item, item.category_id).map(subcategory => subcategory.value).filter(Boolean)
        } else {
          criteria.subcategory_id = []
        }

        return criteria
      });
      console.log('criteria generated:', questionsCriteria);

      if (!questionsCriteria.length) {
        this.isLoading = false;
        return;
      }

      const examId = parseInt(this.$route.params.id);

      axios.post(import.meta.env.VITE_API_BASE_URL + `/api/${this.parentModel}/add-questions-random`, {
        'id': examId, questionsCriteria: questionsCriteria
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }
      }).then((result) => {
        this.isLoading = false;
        this.$toastr.defaultTimeout = 2000;
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          result === 'maxReached' ? "Maximo de preguntas alcanzado" : "Preguntas Generadas."
        );
        console.log(result);
        this.$router.go();

      }).catch((err) => {
        this.isLoading = false;
        this.$toastr.defaultTimeout = 2000;
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.e(
          "Error al crear"
        );
        console.log(err.message);
      });
    },

    onModalHide() { },
    showModal() {
      this.$refs['modal-add-questions-random'].show();
    },
  }
}
</script>

<style scoped>
::v-deep .multiselect {
  display: inline-block;
  vertical-align: middle;
}

::v-deep .multiselect .multiselect__tags {
  display: flex;
  align-items: end;
  padding-top: 0;
  height: 38px;
}
</style>
